import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, Clock, Mic, CheckCircle2, PlayCircle } from "lucide-react";

const TIPS = [
  [Clock, "About 10 minutes, on your own time"],
  [Mic, "Use a quiet spot with a working mic and camera"],
  [CheckCircle2, "Just be yourself. There are no trick questions"],
];

export default function CareerInterview() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    document.title = "Your interview | Saving America Money";
    api.get(`/careers/interview/${token}`).then(({ data }) => setD(data)).catch(() => setErr("This interview link isn't valid. Please check your email or contact us."));
  }, [token]);
  const start = () => {
    api.post(`/careers/interview/${token}/start`).catch(() => {});
    window.open(d.interview_url, "_blank", "noopener");
  };
  if (err) return <div className="mx-auto max-w-xl px-6 py-24 text-center text-sam-slate" data-testid="interview-error">{err}<div className="mt-3"><Link to="/careers" className="font-semibold text-sam-crimson underline">See open roles</Link></div></div>;
  if (!d) return <div className="flex justify-center py-24"><Loader2 className="h-6 w-6 animate-spin text-sam-navy" /></div>;
  return (
    <div className="mx-auto max-w-2xl px-4 sm:px-6 py-14" data-testid="interview-page">
      <div className="text-xs font-bold uppercase tracking-widest text-sam-crimson">Your interview</div>
      <h1 className="mt-2 font-display text-4xl sm:text-5xl font-black text-sam-navy" data-testid="interview-title">Welcome, {d.first_name}!</h1>
      <p className="mt-3 text-sm sm:text-base text-sam-slate">You've been invited to interview for <b className="text-sam-navy">{d.role_title}</b> with Saving America Money. It's a short interview you take on your own. No scheduling needed.</p>
      <ul className="mt-6 space-y-3">
        {TIPS.map(([Icon, t]) => <li key={t} className="flex items-center gap-3 rounded-xl border border-border bg-white p-3 text-sm text-sam-navy"><Icon className="h-4 w-4 text-sam-crimson" />{t}</li>)}
      </ul>
      {d.completed ? (
        <p className="mt-8 rounded-xl bg-sam-green/10 p-4 font-semibold text-sam-green" data-testid="interview-done">You've already finished your interview. Thank you! We'll be in touch soon.</p>
      ) : d.interview_url ? (
        <Button onClick={start} className="mt-8 h-12 w-full bg-sam-crimson text-base font-bold sm:w-auto sm:px-8" data-testid="interview-start"><PlayCircle className="h-5 w-5 mr-2" />Start my interview</Button>
      ) : (
        <p className="mt-8 text-sm text-sam-slate" data-testid="interview-unavailable">The interview isn't open right now. We'll email you as soon as it is.</p>
      )}
    </div>
  );
}
